module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "create-target-form__name-section upload"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": _vm.isNewTarget,
      "targetType": _vm.target.target || _vm.defaultTargetType,
      "initialValue": (_vm.initialTarget || {
        display_name: ''
      }).display_name,
      "disabled": _vm.wasActivated,
      "validateAllNames": !_vm.showActivationButton
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "create-target-form__source-label xandr-create-target__source-label"
  }, [_vm._v("File Type")]), _vm._v(" "), _c('div', {
    staticClass: "create-target-form__source-icons xandr-create-target__source-icons"
  }, _vm._l((_vm.fileTypes), function(fileType) {
    return _c('div', {
      key: fileType.id,
      staticClass: "target-form-upload__destination"
    }, [_c('div', [_c('img', {
      staticClass: "create-target-form__mri-def target-form-upload__destination-icon create-target-form__data-icon--def",
      attrs: {
        "src": _vm.getDestinationImage(fileType)
      },
      on: {
        "click": function($event) {
          return _vm.selectDestination(fileType)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "target-form-upload__destination-title"
    }, [_vm._v(_vm._s(fileType.title))])])])
  }), 0), _vm._v(" "), (!_vm.isXandrUpload) ? [_c('div', {
    staticClass: "target-form-upload__options-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    staticClass: "vue-select",
    attrs: {
      "placeholder": "Select",
      "initialValue": _vm.target.advertiser,
      "disabled": _vm.wasActivated
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    ref: "viewingStreamSelect",
    attrs: {
      "initialValue": _vm.target.viewing_stream,
      "viewingOption": _vm.viewingOptions
    },
    on: {
      "input": _vm.onViewingStreamChange
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.hadStagedFile) ? [_c('div', {
    staticClass: "target-form-upload__options-area",
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-file-input', {
    ref: "fileUploadInput",
    attrs: {
      "accept": _vm.acceptedFileFormat,
      "disabled": _vm.isUploadDisabled || _vm.comscoreSelection != null,
      "placeholder": "No file chosen",
      "prepend-icon": "mdi-microsoft-excel"
    },
    on: {
      "change": _vm.onFileChange,
      "click:clear": _vm.clearSelectedFile
    },
    model: {
      value: (_vm.uploadedFile),
      callback: function($$v) {
        _vm.uploadedFile = $$v
      },
      expression: "uploadedFile"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }, [(_vm.isComscoreDataSource) ? _c('div', {
    staticClass: "target-form-upload__select-area"
  }, [_c('div', {
    staticClass: "evenly-distributed__target-form-dropdown-select",
    class: {
      'absolute-input': this.comscoreSelection != null
    }
  }, [_c('comscore-select', {
    ref: "comscoreSelect",
    staticClass: "vue-select",
    attrs: {
      "disabled": _vm.hadStagedFile || _vm.selectedFiles != null
    },
    on: {
      "update": _vm.onComscoreChange
    }
  })], 1)]) : (_vm.isPIDDataSource) ? _c('div', {
    staticClass: "target-form-upload__select-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.isPIDDataSource) ? _c('v-row', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "4"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "md": "4"
    }
  }, [_c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1)], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "target-form-upload__button-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "3"
    }
  }, [(_vm.showActivationButton) ? _c('action-button', {
    attrs: {
      "label": "activate",
      "id": "uploadModalActivateBtn",
      "color": "secondary",
      "disabled": _vm.disableActivationButton
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedActivate.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "md": "3"
    }
  }, [_c('action-button', {
    attrs: {
      "label": "send downstream",
      "id": "uploadModalSendDownstreamBtn",
      "color": "secondary",
      "disabled": !_vm.uploadButtonClickable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSubmit.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('error-modal', {
    ref: "errorModal",
    attrs: {
      "message": _vm.errorMessage
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c667d0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/TargetFormUpload.vue
// module id = 1979
// module chunks = 0